import {
  FixedMidpointRoundingToDown,
  formatPrice,
} from "utils/helpers/numbers";
import { Grid, TextField } from "@mui/material";

import { TRADE_AMOUNT_TYPE } from "../constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function TradeTotal({ srcDecimalCount, destDecimalCount }) {
  const { watch } = useFormContext();

  const amount = watch("amount");
  const price = watch("price");
  const amountTypeId = watch("amountTypeId");

  const total = useMemo(() => {
    if (amount && price) {
      if (amountTypeId === TRADE_AMOUNT_TYPE.amount.id) {
        const tempVal = +amount * +price || 0;

        return formatPrice(
          FixedMidpointRoundingToDown(tempVal, destDecimalCount)?.toString()
        );
      } else {
        const tempVal = +amount / +price || 0;

        return formatPrice(
          FixedMidpointRoundingToDown(tempVal, srcDecimalCount).toString()
        );
      }
    } else {
      return "";
    }
  }, [amount, amountTypeId, price, destDecimalCount, srcDecimalCount]);

  return (
    <Grid container my={1}>
      <Grid item xs={12}>
        <TextField
          placeholder="Total"
          inputProps={{
            readonly: true,
          }}
          value={total}
          sx={{ textAlign: "center" }}
        />
      </Grid>
    </Grid>
  );
}

export default TradeTotal;
